// Free-text allowlists that keep coding/injection symbols (< > { } [ ] = \ | ` ~ ^ ") out of user input,
// mirroring the Mettle journey's field regexes. Empty passes so `nullable`/`required` govern presence;
// length is left to separate min/max rules.

// Names: letters (incl. accented Latin), spaces, apostrophes and hyphens.
const NAME = /^[A-Za-zÀ-ſ\s'’-]+$/;
// General text (addresses, business name, promo code, claim details): letters, digits, spaces and
// ordinary punctuation/currency — but none of the coding symbols listed above.
const SAFE_TEXT = /^[A-Za-z0-9À-ſ\s'’.,:;!?()&@#%*+/£$€¥_-]+$/;

const passes = (re: RegExp, value: unknown): boolean => {
    if (value === null || value === undefined) return true;
    const v = String(value).trim();
    if (v === '') return true;
    return re.test(v);
};

export const isSafeName = (value: unknown): boolean => passes(NAME, value);
export const isSafeText = (value: unknown): boolean => passes(SAFE_TEXT, value);
